import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {
    MvsApiCrudServiceCommentsInterface
} from "../../../../core/shared/service/api/mvs-api-crud-service-comments.interface";

@Injectable({
    providedIn: 'root'
})
export class CustomerBillingAccountTransactionCommentService extends MvsCrudService implements MvsApiCrudServiceCommentsInterface {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/bm/customerBillingAccountTransactionComments');
    }

    /**
     * Return attribute used to store the comment.
     */
    getCommentAttribute(): string {
        return "comment";
    }

    /**
     * Return whether comments support pinning.
     *
     * TRUE since `bm.CustomerBillingAccountTransactionComment` gained `implements
     * EntityCommentPinned` + the `pinned` column (completing the TM-1000001512 rollout for this
     * entity). It was false before because the attribute did not exist: the pin button would have
     * written to nothing, and - the bigger problem - `true` also makes the comment list sort by
     * `pinned`, which against a missing column breaks the LIST, not just the button.
     *
     * ⚠ Do not set this true for a comment entity that does not implement `EntityCommentPinned`.
     */
    hasCommentPinOption(): boolean {
        return true;
    }

    /**
     * Return linked attribute (required to resolve 1:N relationships).
     * @param objectType
     */
    getLinkedAttribute(objectType: string): string {
        if (objectType === "bm.CustomerBillingAccountTransaction") {
            return "transaction";
        } else {
            return super.getLinkedAttribute(objectType);
        }
    }
}
